// @arch:pure-engine
// planPropose.js — a decisão "este turno é de PROPOR PLANO?" em um lugar puro.
//
// Extraída do handleSend (spine) no guard do incidente PR #618: o chip Plan da
// HOME só embrulhava o TEXTO (MODE_PREFIX.plan) — nenhum hard gate. O modelo que
// ignorasse a diretiva escrevia/commitava direto (foi o que aconteceu). Agora o
// modo 'plan' persistido da sessão de chat (chatModes) liga o plan mode REAL:
// planPropose ⇒ readOnly hard no loop + present_plan como saída.
//
// Regras preservadas do inline anterior (comentários históricos #332/#377/F13-E7-T07):
// - executeApproved NUNCA propõe (o turno de execução pós-aprovação escreve);
// - refiningPlan / chip plan_mode ligam a proposta;
// - heurística looksLikeComplexTask SÓ no Code (no chat, pedido complexo é entrega);
// - NOVO: chatMode==='plan' (chip Plan da home) liga a proposta até a aprovação.
//
// @param {{ refiningPlan?: boolean, planMode?: any, chatMode?: string|null,
//           isChat?: boolean, executeApproved?: boolean, text?: string }} p
// @param {(text:string)=>boolean} looksComplex  injetado (codeAgentMode.looksLikeComplexTask)
// @returns {boolean}
export function decidePlanPropose({ refiningPlan = false, planMode, chatMode = null, isChat = false, executeApproved = false, text = '' }, looksComplex = () => false) {
  if (refiningPlan || planMode) return true; // fiel ao inline: refino/chip vencem tudo
  if (executeApproved) return false; // aprovação ⇒ turno de EXECUÇÃO, nunca re-propor
  if (isChat) return chatMode === 'plan'; // guard PR #618 — Plan da home é hard gate; heurística nunca
  return looksComplex(text); // heurística de complexidade SÓ no Code
}
